var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "cross_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#cross_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.001 8.934 4.734 12.2a.632.632 0 0 1-.466.183.632.632 0 0 1-.467-.184.632.632 0 0 1-.183-.466c0-.189.06-.345.183-.467l3.267-3.266L3.8 4.734a.632.632 0 0 1-.183-.467c0-.189.06-.344.183-.466a.632.632 0 0 1 .467-.184c.189 0 .344.061.466.184l3.267 3.266 3.267-3.266a.632.632 0 0 1 .466-.184c.19 0 .345.061.467.184a.632.632 0 0 1 .183.466.632.632 0 0 1-.183.467L8.934 8l3.267 3.266a.632.632 0 0 1 .183.467.632.632 0 0 1-.183.466.632.632 0 0 1-.467.184.632.632 0 0 1-.466-.184L8 8.934Z"
}))));
export default SvgCross;